import { FormBuilderCartProvider } from "../FormBuilder/cart/formBuilderCartContext";

const withCartProvider = Component => props => {
    return (
        <FormBuilderCartProvider>
            <Component {...props} />
        </FormBuilderCartProvider>
    );
}

export default withCartProvider;